module.exports = __webpack_public_path__ + "static/media/arm-left-back.b5b01c98.png";